import { useState, useEffect } from 'react';
import { authStore } from './AuthStore';

export const useAuthStore = () => {
  const [state, setState] = useState(authStore.getState());

  useEffect(() => {
    const unsubscribe = authStore.subscribe(setState);
    return unsubscribe;
  }, []);

  return {
    ...state,
    setUser: authStore.setUser.bind(authStore),
    clearUser: authStore.clearUser.bind(authStore),
    setLoading: authStore.setLoading.bind(authStore),
  };
};
